export default function Info() {
    return (
        <div id="info">
            <div className="info-row">
                <div className="key-info">Enter</div>
                <div className="key-text-info">- Restart</div>
            </div>
            <div className="info-row">
                <div>
                    <div className="key-info">w</div>
                    <div className="key-info">a</div>
                    <div className="key-info">s</div>
                    <div className="key-info">d</div>
                </div>
                <div className="key-text-info">- Controls</div>
            </div>
        </div>
    );
}
